import React from 'react';

const Pagination = ({ totalPage, currentPage, onChange }) => {
  const handleNext = () => {
    if (currentPage < totalPage) {
      onChange(currentPage + 1);
    }
  };
  const handlePrev = () => {
    if (currentPage > 1) {
      onChange(currentPage - 1);
    }
  };

  const handlePage = (e) => {
    const page = parseInt(e.target.attributes['page'].value);
    onChange(page);
  };

  const renderPages = () => {
    let pages = [];
    if (totalPage >= 10) {
      let s = currentPage - 2;
      if (s < 1) {
        s = 1;
      }
      let p1 = currentPage + 2;
      if (p1 > totalPage) {
        p1 = totalPage;
      }
      for (; s <= p1; s++) {
        pages.push(
          <li class={`page-item ${s == currentPage ? 'active' : ''}`}>
            <a class='page-link' page={s} onClick={handlePage}>
              {s}
            </a>
          </li>
        );
      }
      if (p1 == totalPage) {
        return pages;
      }
      if (s < totalPage - 5) {
        pages.push(
          <li class={`page-item `}>
            <a class='page-link' href='#'>
              ...
            </a>
          </li>
        );
        s = totalPage - 3;
      }
      for (; s <= totalPage; s++) {
        pages.push(
          <li class={`page-item ${s == currentPage ? 'active' : ''}`}>
            <a class='page-link' page={s} onClick={handlePage}>
              {s}
            </a>
          </li>
        );
      }
    } else {
      for (let i = 1; i <= totalPage; i++) {
        pages.push(
          <li class={`page-item ${i == currentPage ? 'active' : ''}`}>
            <a class='page-link' page={i} onClick={handlePage}>
              {i}
            </a>
          </li>
        );
      }
    }
    return pages;
  };
  return (
    <div class='pagination-area pt-30 text-center bt-1 border-color-1'>
      <div class='container'>
        <div class='row'>
          <div class='col-xl-12'>
            <div class='single-wrap d-flex justify-content-center'>
              <nav aria-label='Page navigation example'>
                <ul class='pagination justify-content-start'>
                  <li class='page-item'>
                    <a class='page-link' href='#' onClick={handlePrev}>
                      <i class='flaticon-left'></i>{' '}
                    </a>
                  </li>
                  {renderPages()}
                  <li class='page-item'>
                    <a class='page-link' href='#' onClick={handleNext}>
                      <i class='flaticon-right'></i>{' '}
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Pagination;
